// member_portal/src/config.js

// 部署時，只需要修改這一個文件！
// 🚩 核心修复：改成你的真实域名
export const API_BASE_URL = "https://lluvia.app";